
    import {defineComponent, reactive, toRefs} from 'vue'
    import {useRouter} from "vue-router";

    interface State {
        isBigImg: string;
        isActive: boolean;
    }

    export default defineComponent({
        name: "pageTitle",
        props: {
            isBigImg: {
                type: String,
                default: ''
            },
            backFun: {
                type: String,
                default: ''
            }
        },
        setup(props: any,) {
            let state: State = reactive({
                isBigImg: '',
                isActive: false
            })
            // 获取路由器实例
            const router = useRouter();
            const {isBigImg} = toRefs(props);
            state.isBigImg = isBigImg
            if (state.isBigImg) {
                state.isActive = false
            } else {
                state.isActive = true
            }
            return {
                state,
                router
            }
        },
        methods: {
            goBack() {
                // console.log('返回');
                history.go(-1)
            }
        }
    })
